// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"e2c028b8","436":"4f59ef5a","453":"f394a27d","501":"4f7ab9f9","606":"ff9dc4ff","821":"4b4588af","925":"ecb3a690","969":"20cc78af"}[chunkId] + ".chunk.js";
};